import { Avatar, IconButton, Stack, Typography } from "@mui/material";
import React from "react";
import { APP_ICONS, APP_IMAGES } from "../../assets";

const CustomBar = ({ title }) => {
  return (
    <Stack
      py={1}
      px={2}
      mb={3}
      direction={"row"}
      alignItems={"center"}
      justifyContent={"space-between"}
      bgColor={"secondary.light"}
      borderRadius={"6px"}
      boxShadow={1}
    >
      <Typography variant={"h5"} fontWeight={600} color={"primary.light"}>
        {title}
      </Typography>
      {/* <Stack direction={"row"} alignItems={"center"} gap={1}>
        <IconButton
          sx={{
            bgcolor: "#1863D633",
            padding: "0px",
          }}
        >
          <img src={APP_ICONS.bellBgIconBlue} width={40} height={40} />
        </IconButton>
        <Avatar src={APP_IMAGES.dumyUserImg} />
      </Stack> */}
    </Stack>
  );
};

export default CustomBar;
